import { useContext } from 'react';
import { Box, Group } from '@mantine/core';
import { TabsContext } from '../../Tabs';
import classes from './TabsList.module.css';

type TablistPropsType = React.PropsWithChildren;

export const TabsList: React.FC<TablistPropsType> = ({ children }) => {
  const defaultValue = useContext(TabsContext);

  if (!defaultValue) {
    throw new Error('Tablist must be used within Tabs component');
  }

  return (
    <Group gap={0} align="flex-start">
      {children}
      <Box className={classes.tabsUnderline} />
    </Group>
  );
};
